import { composeIO } from 'react-compose-io'
import { tabelaDetalhesPerdasIO } from './TabelaDetalhesPerdas.IO'
import { TabelaDetalhesPerdasView } from './TabelaDetalhesPerdas.View'

export const TabelaDetalhesPerdas = composeIO(TabelaDetalhesPerdasView, tabelaDetalhesPerdasIO)
